const CTA_HEIGHT = '218px'
const CTA_BUTTON_WIDTH = '186px'

export { CTA_HEIGHT, CTA_BUTTON_WIDTH }
